import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/services/point-of-sale',
    name: 'point of sale',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/PointOfSaleView.vue')
  },
  {
    path: '/services/card-terminals',
    name: 'card-terminals',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/CardTerminalsView.vue')
  },
  
  {
    path: '/services/online-ordering',
    name: 'online-ordering',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/OnlineOrderingView.vue')
  },
  {
    path: '/services/self-serve-kiosks',
    name: 'self-serve-kiosks',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/SelfServeKiosksView.vue')
  },
  {
    path: '/services/cash-advances',
    name: 'cash-advances',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/CashAdvancesView.vue')
  },
  {
    path: '/services/marketing',
    name: 'marketing',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/MarketingView.vue')
  },
  {
    path: '/services/websites',
    name: 'websites',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/WebsitesView.vue')
  },
  {
    path: '/services/apps',
    name: 'apps',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/AppsView.vue')
  },
  {
    path: '/services/all-services',
    name: 'all-services',
    component: () => import(/* webpackChunkName: "about" */ '../views/services/AllServicesView.vue')
  },
  {
    path: '/legal/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "about" */ '../views/legal/TermsView.vue')
  },
  {
    path: '/legal/privacy-policy',
    name: 'privacy-policy',
    component: () => import(/* webpackChunkName: "about" */ '../views/legal/PrivacyPolicyView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
